// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var EBallotEncoding;
(function (EBallotEncoding) {
    EBallotEncoding["SINGLE_CONTEST"] = "SINGLE_CONTEST";
    EBallotEncoding["MULTI_CONTEST"] = "MULTI_CONTEST";
})(EBallotEncoding || (EBallotEncoding = {}));
/**
 * The outcome of re-encrypting the plaintext and randomness carried by an
 * auditable ballot and comparing the result with the ciphertext it carries.
 * A ballot that could not be checked at all is kept apart from one whose
 * ciphertext does not match, because only the latter says anything about the
 * ballot itself.
 */
export var EBallotCiphertextCheck;
(function (EBallotCiphertextCheck) {
    EBallotCiphertextCheck["VERIFIED"] = "VERIFIED";
    EBallotCiphertextCheck["MISMATCH"] = "MISMATCH";
    EBallotCiphertextCheck["NOT_VERIFIABLE"] = "NOT_VERIFIABLE";
})(EBallotCiphertextCheck || (EBallotCiphertextCheck = {}));
/**
 * Re-encrypts the plaintext and randomness carried by the auditable ballot and
 * compares the result with the ciphertext it carries. Only VERIFIED lets the
 * ballot through, so the caller fails closed on the other two outcomes.
 */
export var checkAuditableBallotCiphertext = function (ballotService, auditableBallot, encoding) {
    try {
        var isConsistent = encoding === EBallotEncoding.MULTI_CONTEST
            ? ballotService.verifyAuditableMultiBallotCiphertext(auditableBallot)
            : ballotService.verifyAuditableBallotCiphertext(auditableBallot);
        return isConsistent ? EBallotCiphertextCheck.VERIFIED : EBallotCiphertextCheck.MISMATCH;
    }
    catch (error) {
        // The ballot could not be checked at all: a missing or malformed public
        // key, contests that do not match the ballot style, or a ballot read
        // with the wrong codec. None of that is evidence of a forged
        // ciphertext, so it must not be reported as one.
        console.log(error);
        return EBallotCiphertextCheck.NOT_VERIFIABLE;
    }
};
